var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98094 22.3209H0.367561V7.46419H4.98094V22.3209ZM2.67177 5.43759C1.19656 5.43759 0 4.21567 0 2.74043C1.05589e-08 2.03182 0.281489 1.35223 0.782543 0.851164C1.2836 0.350099 1.96317 0.0686035 2.67177 0.0686035C3.38036 0.0686035 4.05994 0.350099 4.56099 0.851164C5.06205 1.35223 5.34353 2.03182 5.34353 2.74043C5.34353 4.21567 4.14648 5.43759 2.67177 5.43759ZM22.2473 22.3209H17.6439V15.0888C17.6439 13.3652 17.6091 11.1548 15.2453 11.1548C12.8467 11.1548 12.4792 13.0274 12.4792 14.9646V22.3209H7.87076V7.46419H12.2954V9.49078H12.36C12.9759 8.3235 14.4804 7.09165 16.725 7.09165C21.394 7.09165 22.2523 10.1663 22.2523 14.1599V22.3209H22.2473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.56c44112fe48464a9e775ef317dcb9bc.svg";
export { ForwardRef as ReactComponent };